import type { ControllerProfile } from './types'

/**
 * Generic controller profile.
 * Fallback profile for unknown controllers, using common/default mappings.
 */
export const genericProfile: ControllerProfile = {
  id: 'generic',
  name: 'Generic Controller',
  buttons: {
    select: 0,   // First button (often A/Cross)
    exit: 1,     // Second button (often B/Circle)
    configure: 2, // Third button (often X/Square)
    menu: 9,     // Menu/Options button
    rightBumper: 5,  // Right bumper (RB) - same behavior as select
  },
  axes: {
    leftStick: { x: 0, y: 1 },
    rightStick: { x: 2, y: 3 },
  },
  dpad: {
    up: 12,
    down: 13,
    left: 14,
    right: 15,
  },
  deadzone: 0.3,
}
